import React, { useContext, useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import { AuthContext } from "../../../../auth-context";
import { getPortalLogs } from "../../../../api";
import LogFilters from "./components/log-filters";
import LogTable from "./components/log-table";
import LogPagination from "./components/log-pagination";

const Container = styled.div`
  margin: 0 auto;
  max-width: 1600px;
  padding: 24px 16px 64px 16px;
`;

const defaultFilters = {
  action_type: "",
  actor_id: "",
  date_from: "",
  date_to: ""
};

const Logs = () => {
  const { user } = useContext(AuthContext);
  const [logs, setLogs] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [filters, setFilters] = useState(defaultFilters);
  const [appliedFilters, setAppliedFilters] = useState(defaultFilters);

  const limit = 50;

  const actorOptions = useMemo(() => {
    const options = [];
    if (user) {
      options.push({ id: user.id, name: user.name, email_address: user.email_address });
      if (Array.isArray(user.team)) {
        user.team.forEach((member) => options.push(member));
      }
    }

    const unique = {};
    return options.filter((entry) => {
      if (!entry || !entry.id) return false;
      if (unique[entry.id]) return false;
      unique[entry.id] = true;
      return true;
    });
  }, [user]);

  useEffect(() => {
    if (!user) return;

    const params = {
      limit,
      offset: page * limit
    };

    Object.keys(appliedFilters).forEach((key) => {
      if (appliedFilters[key]) params[key] = appliedFilters[key];
    });

    setLoading(true);
    setError("");
    getPortalLogs(user.id, params)
      .then((res) => {
        setLogs(res.data.logs || []);
        setTotal(res.data.total || 0);
      })
      .catch(() => {
        setError("Unable to load logs.");
      })
      .finally(() => setLoading(false));
  }, [user, page, appliedFilters]);

  const applyFilters = () => {
    setPage(0);
    setAppliedFilters(filters);
  };

  const clearFilters = () => {
    setPage(0);
    setAppliedFilters(defaultFilters);
  };

  return (
    <Container>
      <LogFilters
        filters={filters}
        actorOptions={actorOptions}
        onFiltersChange={setFilters}
        onApply={applyFilters}
        onClear={clearFilters}
      />
      <LogTable
        logs={logs}
        loading={loading}
        error={error}
      />
      {!loading && !error && (
        <LogPagination
          total={total}
          limit={limit}
          page={page}
          onPageChange={setPage}
        />
      )}
    </Container>
  );
};

export default Logs;
